import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Provision } from '../../models/provision';
import { ProvisionService } from 'src/services/provision/provision.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProvisionHeader } from 'src/models/provisionheader';
import { StructureService } from 'src/services/structure/structure.service';
import { UserService } from 'src/services/user/user.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    selector: 'conversion-saveas',
    templateUrl: './saveas.component.html',
    styleUrls: ['./saveas.component.css']
})

export class SaveAsComponent implements OnInit {
    constructor(private provisionService: ProvisionService,
                public activeModal: NgbActiveModal,
                private structureService: StructureService,
                private userService: UserService) { }

    provision: Provision
    provisionName: string
    provisionUserName: string = '';
    userProvisions = new Array<ProvisionHeader>();
    alreadyExists: boolean;

    ngOnInit(): void {
        this.provision = this.provisionService.getProvision();
        this.provisionName = this.provision.Name;
        this.userService.getUserUpdates().subscribe(user => {
            this.provisionUserName = user.provisionsUserName;
            this.getUserProvisions(this.provisionUserName);
        });
    }

    getUserProvisions(provisionUserName: string) {
        this.userProvisions= new Array<ProvisionHeader>();
        if (!provisionUserName) { return; }
            this.structureService.getProvisionsForUser(provisionUserName).subscribe(
                data => {
                    if(Array.isArray(data)) {
                        this.userProvisions = data.map(ph => {
                            return ProvisionHeader.fromApi(ph);
                        });    
                        this.checkIfExisting();
                    }
                });
    }

    checkIfExisting(){
        var x = this.userProvisions.find(x => x.ProvisionName == this.provisionName);
        x ? this.alreadyExists = true : this.alreadyExists = false;
    }
}